/**
 * @fileOverView
 * @description Maintenance Page View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

var MaintenancePageTemplate = require('../../templates/pages/maintenancepage.html');
var AmpersandView = require('ampersand-view');
var HeaderView = require('../widgets/header');

var app = require('ampersand-app');

var MaintenancePage = AmpersandView.extend({

    template : MaintenancePageTemplate,

    render: function(){
        this.renderWithTemplate();
    },

    subviews: {
        mpheader: {
            selector: 'header',
            prepareView: function (el) {
                return new HeaderView({
                    el: el,
                    parent: this,
                    noback: true,
                    login: true,
                    maintitle: 'Vybit is Down for Maintenance :('
                });
            }
        }
    }
});

module.exports = MaintenancePage;
